import { render, staticRenderFns } from "./wplOrder.vue?vue&type=template&id=6c304101"
import script from "./wplOrder.vue?vue&type=script&lang=js"
export * from "./wplOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports